import Attachment from 'models/attachment';
import { createContentModel, isEmpty } from './composition_content_shared';
import { prop } from 'models/lib/create_model';

const TaskThreadReplyCompositionContent = createContentModel({
  modelName: 'TaskThreadReplyCompositionContent',

  properties: {
    taskId: prop(String).isRequired,
    bcc: String,
    bodyHtml: String,
    cc: String,
    dueAt: String,
    from: String,
    inlineAttachments: prop([Attachment]).default([]),
    subject: String,
    to: String,
  },

  setRecipients({ tos, ccs, bccs }) {
    this.to = tos.join(', ');
    this.cc = ccs.join(', ');
    this.bcc = bccs.join(', ');
  },

  setFrom(from) {
    this.from = from;
  },

  addInlineAttachments(inlineAttachments) {
    this.inlineAttachments = this.inlineAttachments.concat(inlineAttachments);
  },

  isEmpty() {
    return isEmpty(this.bodyHtml);
  },
});

TaskThreadReplyCompositionContent.MAX_SINGLE_ATTACHMENT_SIZE_MB = 15;

export function isTaskThreadReply(composition) {
  return composition.content instanceof TaskThreadReplyCompositionContent;
}

export default TaskThreadReplyCompositionContent;
